import React from "react";
import { ReplicateSpaceOptionsInputType } from "../../generated/types";
import { ReplicateSpaceModal, SpaceWithName } from "./ReplicateSpaceModal";

interface ReplicateSpaceEditorProps {
  space: SpaceWithName;
  onReplicateSpace: (
    id: string,
    newParentId: string,
    options: ReplicateSpaceOptionsInputType,
    newSpaceName?: string,
    newFloorHeight?: number,
  ) => Promise<void>;
  onClose: () => void;
}

export const ReplicateSpaceEditor = (props: ReplicateSpaceEditorProps) => {
  const { space, onReplicateSpace, onClose } = props;

  const onCreateCallback = async (
    spaceId: string,
    parentSpaceId: string,
    options: ReplicateSpaceOptionsInputType,
    newSpaceName?: string,
    newFloorHeight?: number,
  ) => {
    await onReplicateSpace(
      spaceId,
      parentSpaceId,
      options,
      newSpaceName,
      newFloorHeight,
    );
    onClose();
  };

  return (
    <ReplicateSpaceModal
      space={space}
      onCreate={onCreateCallback}
      onClose={onClose}
    />
  );
};
